import { render } from "./MenuContentItemSelectionGroup.vue?vue&type=template&id=36071bea&scoped=true"
import script from "./MenuContentItemSelectionGroup.vue?vue&type=script&lang=js"
export * from "./MenuContentItemSelectionGroup.vue?vue&type=script&lang=js"

import "./MenuContentItemSelectionGroup.vue?vue&type=style&index=0&id=36071bea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36071bea"]])

export default __exports__